/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RequestedExpertDocumentResponseDto = {
    /**
     * ID of the requested expert document record
     */
    id: string;
    /**
     * Expert ID for whom the document is requested
     */
    expertId: string;
    /**
     * Specific document type requested (e.g. first_aid_certification). Stored and returned so the frontend can show what the admin asked for.
     */
    documentType: RequestedExpertDocumentResponseDto.documentType;
    /**
     * Current status of the requested document
     */
    status: RequestedExpertDocumentResponseDto.status;
    /**
     * Optional message or reason for the request, stored as rejection_reason for the placeholder record
     */
    message: Record<string, any> | null;
};
export namespace RequestedExpertDocumentResponseDto {
    /**
     * Specific document type requested (e.g. first_aid_certification). Stored and returned so the frontend can show what the admin asked for.
     */
    export enum documentType {
        CPR_CERTIFICATION = 'cpr_certification',
        FIRST_AID_CERTIFICATION = 'first_aid_certification',
        PT_CERTIFICATION = 'pt_certification',
        HIGHEST_EDUCATION = 'highest_education',
        BACHELORS_DEGREE = 'bachelors_degree',
        MASTERS_DEGREE = 'masters_degree',
        INTERNSHIP_CERTIFICATE = 'internship_certificate',
        PROFESSIONAL_LICENSE = 'professional_license',
        WORK_EXPERIENCE_PROOF = 'work_experience_proof',
        MA_MSC_PSYCHOLOGY = 'ma_msc_psychology',
        MPHIL_PSYD = 'mphil_psyd',
        CHILD_CERTIFICATION = 'child_certification',
        ACTIVE_LISTENING_TRAINING = 'active_listening_training',
        ADDITIONAL_CERTIFICATION = 'additional_certification',
        OTHER = 'other',
        PASSPORT = 'passport',
        EMIRATES_ID = 'emirates_id',
        AADHAR_CARD = 'aadhar_card',
    }
    /**
     * Current status of the requested document
     */
    export enum status {
        PENDING = 'pending',
        VERIFIED = 'verified',
        REJECTED = 'rejected',
        RESUBMISSION_REQUIRED = 'resubmission_required',
    }
}

